import api from "./client";

export const listSiteSensorInventory = async (siteId) => {
  const { data } = await api.get(`/sites/${siteId}/sensor-inventory`);
  return data;
};

export const upsertSiteSensorInventory = async (siteId, signalMatchId, payload) => {
  const { data } = await api.put(`/sites/${siteId}/sensor-inventory/${signalMatchId}`, payload);
  return data;
};

export const uploadSiteSensorCertificate = async (siteId, sensorInventoryId, file, uploadedBy) => {
  const formData = new FormData();
  formData.append("file", file);
  if (uploadedBy) {
    formData.append("uploaded_by", uploadedBy);
  }
  const { data } = await api.post(`/sites/${siteId}/sensor-inventory/${sensorInventoryId}/certificate`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const deleteSiteSensorCertificate = async (siteId, sensorInventoryId) => {
  const { data } = await api.delete(`/sites/${siteId}/sensor-inventory/${sensorInventoryId}/certificate`);
  return data;
};
